import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { fetchPrepContextForSource } from "@/services/frontendServices/prepContextServices";
import { PrepContextDto, PrepSource } from "@/types";

import { prepSourceKey } from "./usePrep";

export const prepContextKeys = {
  all: ["prepContext"] as const,
  detail: (prepSourceId: string) =>
    [...prepContextKeys.all, prepSourceId] as const,
};

export const usePrepContext = (
  source: PrepSource,
  options?: Partial<UseQueryOptions<PrepContextDto, Error>>
) =>
  useQuery<PrepContextDto, Error>({
    queryKey: prepContextKeys.detail(prepSourceKey(source)),
    queryFn: () => fetchPrepContextForSource(source),
    enabled: true,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
    ...options,
  });
